// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"55":"e2dc4cc22dc5e44f","761":"26285d5950a11f5e","782":"d6a1c19a87fe9b04"}[chunkId] + ".js";
};